// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__doxzR","title":"styles_title__4uvb9","list":"styles_list__lVp8J","label":"styles_label__3P4+g","error":"styles_error__5dfDg","radio":"styles_radio__ALa5e"};